export default "__VITE_ASSET__Dzjuol2Z__$_?nuxt_component=async&nuxt_component_name=SvgoUs&nuxt_component_export=default__"